/**
 * @file BillingFeeBreakdownTab.js
 * @description Placeholder tab for the Fee Breakdown feature, pending a finalized product spec.
 */

import { getText } from '../../../i18n';

const BillingFeeBreakdownTab = () => (
    <div className="col-12 text-center py-5">
        <p className="fs-5" style={{ color: 'rgba(47, 43, 67, 0.6)' }}>
            {getText('msg_ffcc4db7e567')}
        </p>
    </div>
);

export default BillingFeeBreakdownTab;
